
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { isCloudflareWorker, safeExecute } from './utils/environment.ts'
import { trackPageView } from './utils/analytics.ts'

// Track initial page view
trackPageView(window.location.pathname);

// Listen for route changes
if (typeof window !== 'undefined') {
  window.addEventListener('popstate', () => {
    trackPageView(window.location.pathname);
  });
}

// Add specialized error handling for Cloudflare Workers
const renderApp = () => {
  try {
    const root = document.getElementById("root");
    
    if (!root) {
      console.error("Root element not found!");
      return;
    }
    
    // Special handling for Cloudflare Workers environment
    if (isCloudflareWorker()) {
      console.log("Running in Cloudflare Workers environment, applying special rendering optimizations");
      
      // Use a setTimeout to ensure the DOM is fully initialized
      // This can help with some Cloudflare Worker initialization issues
      setTimeout(() => {
        safeExecute(
          () => {
            createRoot(root).render(<App />);
            return;
          },
          () => {
            // Fallback rendering if createRoot fails in Cloudflare environment
            root.innerHTML = `
              <div style="max-width: 600px; margin: 50px auto; padding: 20px; text-align: center; font-family: system-ui, sans-serif;">
                <h2>Loading Application...</h2>
                <p>Please wait while we initialize the application in this environment.</p>
                <button onclick="window.location.reload()" style="margin-top: 20px; padding: 10px 20px; background: #3b82f6; color: white; border: none; border-radius: 5px; cursor: pointer;">
                  Refresh Page
                </button>
              </div>
            `;
            return;
          }
        );
      }, 100);
    } else {
      // Standard rendering for non-Cloudflare environments
      createRoot(root).render(<App />);
    }
  } catch (error) {
    console.error("Critical error rendering application:", error);
    
    // Display fallback UI in case of critical error
    const rootElement = document.getElementById("root");
    if (rootElement) {
      rootElement.innerHTML = `
        <div style="max-width: 600px; margin: 50px auto; padding: 20px; text-align: center; font-family: system-ui, sans-serif;">
          <h2>Something went wrong</h2>
          <p>We're sorry, but the application couldn't be loaded correctly.</p>
          <p>Please try refreshing the page or try again later.</p>
          <button onclick="window.location.reload()" style="margin-top: 20px; padding: 10px 20px; background: #3b82f6; color: white; border: none; border-radius: 5px; cursor: pointer;">
            Refresh Page
          </button>
        </div>
      `;
    }
  }
};

renderApp();
